import React from 'react'
import { IProspectsCardsProps } from '../ProspectsCards'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { LayoutCardsColumns } from '../ProspectsCards.styles'
import Dropdown from 'src/components/common/Dropdown/Dropdown'
import { useSelector } from 'react-redux'
import { selectProspects } from 'src/redux/prospects/prospectsSlice'
import { formatDate } from 'src/helpers/formatDate'

const ProspectsUserInfo = ({ prospect, loading }: IProspectsCardsProps) => {
    const { selectedSection: { type } } = useSelector(selectProspects)
    const typeProspect = Boolean(type - 1)

    if (loading) return (
        <>
            <SkeletonLoader width='254px' height='20px' count={3} />
            <SkeletonLoader width='180px' height='20px' count={2} />
            <SkeletonLoader width='200px' height='20px' count={3} />
            <SkeletonLoader width='117px' height='20px' />
        </>
    )

    return (
        <LayoutCardsColumns>
            <div className='containerLabel gap-10'>
                <span className="label">Nombre:</span>
                <b>{prospect.fullname}</b>
            </div>
            <div className='containerLabel gap-10 bg-grey'>
                <span className="label">Número:</span>
                <b>{prospect.phone_contact}</b>
                <span className="label">Whatsapp:</span>
                <b>{prospect.phone_whatsapp}</b>
            </div>
            <div className='containerLabel gap-10'>
                <span className="label">Correo:</span>
                {prospect.email_contact}
            </div>
            {
                !typeProspect &&
                <div className='containerLabel gap-10 bg-grey'>
                    <span className="label">ID:</span>
                    {prospect.user_id}
                </div>
            }
            <div className={`containerLabel gap-10 ${typeProspect ? 'bg-grey' : ''}`}>
                <span className="label">Registro:</span>
                <b>{formatDate(prospect.created, 'No registrado')}</b>
            </div>
            <div className={`containerLabel gap-10 ${!typeProspect ? 'bg-grey' : ''}`}>
                <span className="label">Tipo:</span>
                {
                    prospect.user_type &&
                    <Dropdown
                        colorSelect='grey-light'
                        isDisabled={true}
                        messageTag={prospect.user_type}
                    />
                }
            </div>
            <div className={`containerLabel gap-10 ${typeProspect ? 'bg-grey' : ''}`}>
                <span className="label">Tamaño:</span>
                {
                    prospect.user_size &&
                    <Dropdown
                        colorSelect='grey-light'
                        isDisabled={true}
                        messageTag={prospect.user_size}
                    />
                }
            </div>
            {
                typeProspect &&
                <div className='containerLabel gap-10'>
                    <span className="label">Fuente:</span>
                    {
                        prospect.campaign &&
                        <Dropdown
                            colorSelect='grey-light'
                            isDisabled={true}
                            messageTag={prospect.campaign}
                        />
                    }
                </div>
            }
        </LayoutCardsColumns>
    )
}

export default ProspectsUserInfo